// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		suggestionProductItemPerRow: 1
		//suggestionMode: 'test',
		//suggestionPosition: 'left'
	}
};

(function() {
	BoostPFS.inject(this);

	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function() {
		var suggestionElement = this.$uiMenuElement;
		var searchElement = this.$element;
		var searchBoxId = this.id;
	};

    InstantSearchApi.beforeCall = function(searchTerm) {
    /* Change the params before calling api */
      Globals.instantSearchQueryParams.sort = 'created-descending';
      Globals.instantSearchQueryParams.currency = boostPFSConfig.general.current_currency.toLowerCase();
      Globals.instantSearchQueryParams.currency_rate = Shopify.currency.rate;
    }
})();